import { Splide } from '@splidejs/splide';

window.addEventListener('DOMContentLoaded', () => {
  const splideConfig = {
    autoWidth: true,
    pagination: false,
    focus: 0,
    omitEnd: true,
    role: 'categories carousel',
    perMove: 5,
    breakpoints: {
      768: {
        destroy: true
      }
    }
  };

  const categories = document.querySelectorAll('.splide--categories');

  for (const category of categories) {
    new Splide(category, splideConfig).mount();
  }

  if (categories) {
    new Splide('.splide--categories', splideConfig).mount();
  }
});
